/* tslint:disable */
/* eslint-disable */
/* @relayHash 2722e417ed60fddf95615c903ccd6f8a */

import { ConcreteRequest } from "relay-runtime";
export type CreateWordOrderExerciseInput = {
    worksheetId: string;
    content: WordOrderExerciseContentInput;
    position: number;
    clientMutationId?: string | null;
};
export type WordOrderExerciseContentInput = {
    correctAnswers: Array<string>;
    scrambledParts: Array<string>;
};
export type CreateWordOrderExerciseMutationVariables = {
    input: CreateWordOrderExerciseInput;
};
export type CreateWordOrderExerciseMutationResponse = {
    readonly createWordOrderExercise: {
        readonly exercise: {
            readonly id: string;
            readonly content: {
                readonly correctAnswers: ReadonlyArray<string>;
                readonly scrambledParts: ReadonlyArray<string>;
            };
            readonly worksheet: {
                readonly id: string;
            };
        } | null;
    } | null;
};
export type CreateWordOrderExerciseMutation = {
    readonly response: CreateWordOrderExerciseMutationResponse;
    readonly variables: CreateWordOrderExerciseMutationVariables;
};



/*
mutation CreateWordOrderExerciseMutation(
  $input: CreateWordOrderExerciseInput!
) {
  createWordOrderExercise(input: $input) {
    exercise {
      id
      content {
        correctAnswers
        scrambledParts
      }
      worksheet {
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateWordOrderExerciseInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createWordOrderExercise",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateWordOrderExercisePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "exercise",
        "storageKey": null,
        "args": null,
        "concreteType": "WordOrderExercise",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "content",
            "storageKey": null,
            "args": null,
            "concreteType": "WordOrderExerciseContent",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "correctAnswers",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "scrambledParts",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "worksheet",
            "storageKey": null,
            "args": null,
            "concreteType": "Worksheet",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateWordOrderExerciseMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateWordOrderExerciseMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateWordOrderExerciseMutation",
    "id": null,
    "text": "mutation CreateWordOrderExerciseMutation(\n  $input: CreateWordOrderExerciseInput!\n) {\n  createWordOrderExercise(input: $input) {\n    exercise {\n      id\n      content {\n        correctAnswers\n        scrambledParts\n      }\n      worksheet {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'ab48118cac8135b3741860214d3f9232';
export default node;
